import styled, { css } from 'styled-components';

import { Button, TextField } from '@speeki/global-ui-components';

export const ButtonsWrapper = styled.div`
    display: flex;
    margin-top: 10px;
`;

export const RadioButton = styled(Button)`
    min-width: 144px;

    & ~ & {
        margin-left: 8px;
    }
`;

export const PhoneInputsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const PhoneInputsRow = styled.div`
    display: grid;
    grid-template-columns: 100px 1fr;
`;

export const PrefixInput = styled(TextField)(
    ({ error }) => css`
        input {
            border-right: none;

            ${error &&
            css`
                &:focus {
                    border-right-width: 1px;
                }
            `}
        }
    `,
);
